<div class="grid-container grid-1">
    <widget-card [cardTitle]="'WIDGET.PERFORMANT_SITES.TOP' | translate" [showPeriod]="true">
        <developer-helper [datasourceCode]="OldDataSourceCode.BUILDING_INDICATOR" />
        @if (sitesTop && !isLoading && !loadingError) {
            @if (sitesTop && sitesTop.length) {
                <table>
                    @for (site of sitesTop; track site) {
                        <tr class="buildingRow" (click)="goToBuildingHome(site.buildingId)">
                            <td>{{ site.name }}</td>
                            <td>{{ trunc(site.epiValue) }} &nbsp; {{ site.epiDisplayUnit }}</td>
                        </tr>
                    }
                </table>
            } @else {
                <p padding>{{ 'WIDGET.PERFORMANT_SITES.NO_TOP' | translate }}</p>
            }
        } @else {
            <loading-and-error padding [isLoading]="isLoading" [hasError]="loadingError" />
        }
    </widget-card>

    <widget-card [cardTitle]="'WIDGET.PERFORMANT_SITES.FLOP' | translate" [showPeriod]="true">
        <developer-helper [datasourceCode]="OldDataSourceCode.BUILDING_INDICATOR" />
        @if (sitesFlop && !isLoading && !loadingError) {
            @if (sitesFlop && sitesFlop.length) {
                <table>
                    @for (site of sitesFlop; track site) {
                        <tr class="buildingRow" (click)="goToBuildingHome(site.buildingId)">
                            <td>{{ site.name }}</td>
                            <td>{{ trunc(site.epiValue) }} &nbsp; {{ site.epiDisplayUnit }}</td>
                        </tr>
                    }
                </table>
            } @else {
                <p padding>{{ 'WIDGET.PERFORMANT_SITES.NO_FLOP' | translate }}</p>
            }
        } @else {
            <loading-and-error padding [isLoading]="isLoading" [hasError]="loadingError" />
        }
    </widget-card>
</div>
